import { UserContext, WorkSpaceContext } from "@/infrastructure/context";
import { AppConfig } from "../config";
import { ConsoleAdapter, getRequestContext, initLogger, LoggerAdapter, MultiAdapter, isEnvironment } from "./index";
import { LogContext } from "./logger.context";
import { SentryLogger } from "./sentry.logger.processor";

const config = AppConfig.getInstance();


export class LoggerFactory {
    private static _instance: LoggerFactory;
    private readonly currentLogger: string;
    private readonly logContext: LogContext;

    public static getInstance(): LoggerFactory {
        if (!LoggerFactory._instance) {
            LoggerFactory._instance = new LoggerFactory();
        }
        return LoggerFactory._instance;
    }

    private constructor() {
        this.currentLogger = config.CURRENT_LOGGER;
        const user = UserContext.getInstance().getUser();
        const workspace = WorkSpaceContext.getInstance().getWorkSpace();

        this.logContext = {
            environment: config.SENTRY_ENVIRONMENT,
            version: config.VERSION,
            brand: {
                brand_name: workspace?.workspaceName,
                brand_key: workspace?.workspaceKey,
            },
            user: {
                username: user?.fullName,
                email: user?.email,
            },
        }

        const adapters: LoggerAdapter[] = [new ConsoleAdapter()];

        if (isEnvironment(config.SENTRY_ENVIRONMENT)) {
            if (this.currentLogger === "SENTRY") {
                adapters.push(new SentryLogger({
                    dsn: config.SENTRY_DSN,
                    context: this.logContext,
                    environment: config.SENTRY_ENVIRONMENT,
                    replaysSessionSampleRate: config.SENTRY_ENVIRONMENT === "PROD" ? 0.1 : 1,
                    replaysOnErrorSampleRate: config.SENTRY_ENVIRONMENT === "PROD" ? 0.1 : 1,
                }));
            }

            initLogger({
                service_name: config.SENTRY_SERVICE_NAME,
                environment: config.SENTRY_ENVIRONMENT,
                min_level: config.LOG_LEVEL,
                hide_meta: true,
                global_meta: {
                    version: config.VERSION,
                    brand: this.logContext.brand,
                    user: this.logContext.user,
                    data_provider: this.logContext.dataProvider,
                },
                context_provider: getRequestContext,
            }, new MultiAdapter(adapters));

        }

    }
}

